/** SECTION: Gesture options
 *
 * Gesture options which are used to type the various trigger and release event props
 *
 */
export var DNAGestureDirections;
(function (DNAGestureDirections) {
    DNAGestureDirections[DNAGestureDirections["up"] = 0] = "up";
    DNAGestureDirections[DNAGestureDirections["down"] = 1] = "down";
    DNAGestureDirections[DNAGestureDirections["left"] = 2] = "left";
    DNAGestureDirections[DNAGestureDirections["right"] = 3] = "right";
})(DNAGestureDirections || (DNAGestureDirections = {}));
export var DNASwipeGestureEdges;
(function (DNASwipeGestureEdges) {
    DNASwipeGestureEdges[DNASwipeGestureEdges["top"] = 0] = "top";
    DNASwipeGestureEdges[DNASwipeGestureEdges["right"] = 1] = "right";
    DNASwipeGestureEdges[DNASwipeGestureEdges["left"] = 2] = "left";
    DNASwipeGestureEdges[DNASwipeGestureEdges["bottom"] = 3] = "bottom";
})(DNASwipeGestureEdges || (DNASwipeGestureEdges = {}));
/** TODO: Align with product & design on best defaults */
export var DNASwipeLengths;
(function (DNASwipeLengths) {
    DNASwipeLengths[DNASwipeLengths["long"] = 200] = "long";
    DNASwipeLengths[DNASwipeLengths["short"] = 100] = "short";
})(DNASwipeLengths || (DNASwipeLengths = {}));
export var DNASwipeSpeeds;
(function (DNASwipeSpeeds) {
    /** TODO: Align with product and design on best defaults */
    DNASwipeSpeeds[DNASwipeSpeeds["slow"] = 400] = "slow";
    DNASwipeSpeeds[DNASwipeSpeeds["fast"] = 200] = "fast";
})(DNASwipeSpeeds || (DNASwipeSpeeds = {}));
/** !SECTION: Gesture Release Events */
//# sourceMappingURL=DNAGestureDetector.types.js.map